/**
 * Change the link to the data protection statement depending on the value of the country select box.
 */
document.addEventListener('change', (event) => {
    const element = event.target;
    if (element && element.matches('.customer-registration__country')) {
        const value = element.value.toLowerCase();
        let found = false;
        const labels = document.getElementsByClassName('customer-registration__data-protection-label');
        for (const label of labels) {
            if (label.dataset.country.toLowerCase() === value) {
                found = true;
                label.classList.add('customer-registration__data-protection-label--active');
            } else {
                label.classList.remove('customer-registration__data-protection-label--active');
            }
        }
        if (!found) {
            labels[0].classList.add('customer-registration__data-protection-label--active');
        }
    }
});

/**
 * Show/Hide password buttons
 */
(function () {
    const passwordInput = document.getElementById('form-password');
    const confirmationInput = document.getElementById('form-password-confirmation');
    const revealButtons = document.getElementsByClassName('password-reveal-button');
    const passwordButton = revealButtons[0];
    const confirmationButton = revealButtons[1];
    const form = passwordInput ? passwordInput.closest('form') : null;
    if (!form || !passwordInput || !confirmationInput || !passwordButton || !confirmationButton) {
        return;
    }

    // Only show the button if the corresponding input is not empty.
    const onInputChange = (input, button) => () => {
        if (input.value.trim() === '') {
            button.style.display = 'none';
        } else {
            button.style.display = 'block';
        }
    };
    passwordInput.addEventListener('input', onInputChange(passwordInput, passwordButton));
    confirmationInput.addEventListener('input', onInputChange(confirmationInput, confirmationButton));
    // Initial hide if necessary:
    onInputChange(passwordInput, passwordButton)();
    onInputChange(confirmationInput, confirmationButton)();

    // Switch between input type password and text when clicking on a button. Changes the input type of both fields.
    // when clicking on one of the buttons.
    const onButtonClick = () => {
        if (passwordInput.type === 'password') {
            passwordInput.type = 'text';
            confirmationInput.type = 'text';
            passwordButton.innerText = form.dataset.hidePasswordText;
            confirmationButton.innerText = form.dataset.hidePasswordText;
        } else {
            passwordInput.type = 'password';
            confirmationInput.type = 'password';
            passwordButton.innerText = form.dataset.showPasswordText;
            confirmationButton.innerText = form.dataset.showPasswordText;
        }
    };
    passwordButton.addEventListener('click', onButtonClick);
    confirmationButton.addEventListener('click', onButtonClick);
})();
